/**
 * 事業場
 */
import Vue from "vue";
import * as httpConst from "../../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/trader_location_members`;

const search_trader_location_member = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * @param commit
     * @param query { Object } 検索条件
     * @property query.search_type { string } モード: transport or trader or either
     * @property query.trader_id { Number } 事業者ID
     * @property query.name { string } 名称
     * @property query.exclude_me { boolean } 自身を除外する
     * @property query.own_disposer { Boolean } 自社処分のみ
     * @property query.with_final_disposer { Boolean } 最終処分を含む
     * @param page { number } ページ番号
     * @returns
     */
    index({ commit }, { query, page }) {
      const params = {
        ...query,
        page: page,
        limit: 30,
      };
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then((data) => {
          resolve(data.content);
        });
      });
    },
    show({ commit }, { id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}`).then((data) => {
          resolve(data.content);
        });
      });
    }
  },
  mutations: {},
};
export default search_trader_location_member;
